import * as Api from '@ViewModels';
import { useMemo } from 'react';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { getDisplayName, getPrincipalInitials } from '../../models/NameUtils';
import { useLoadAllUsers } from '../../queries/User/useLoadAllUsers';

export function useUserNames({ enabled = true }: { enabled?: boolean } = {}) {
	const userSession = useUserSession();
	const { users, isLoading } = useLoadAllUsers({ enabled });

	const usersById = useMemo(() => new Map<string, Api.IUser>(users.map(user => [user.id, user])), [users]);

	const nameFor = (userId?: string) => {
		if (!userId) {
			return 'Someone';
		}
		if (userId === userSession.user?.id) {
			return 'You';
		}
		const user = usersById.get(userId);
		return user ? getDisplayName(user) : 'A teammate';
	};

	const initialsFor = (userId?: string) => {
		const user = userId ? usersById.get(userId) : undefined;
		return user ? getPrincipalInitials(user) : '?';
	};

	return { initialsFor, isLoading, nameFor, users };
}
